import React from "react";
import PropTypes from "prop-types";

import style from "./style.module.css";

const TabList = ({ tabs, selected, onClick, className }) => {
  return (
    <div className={`${style.wrapper} ${className}`}>
      {tabs.map(tab => (
        <div
          key={`tablist-${tab.id}`}
          className={selected === tab.id ? style.active : style.tab}
          onClick={() => onClick(tab.id)}
        >
          {tab.label}
        </div>
      ))}
    </div>
  );
};

TabList.propTypes = {
  tabs: PropTypes.arrayOf(Object).isRequired,
  selected: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired,
  className: PropTypes.string
};

export default TabList;
